import { goBack } from "assets/icons";
import styled from "@emotion/styled";
import { Card, Col, Form, message, Row, Typography } from "antd";
import { useNavigate } from "react-router-dom";
import { useState } from "react";
import _ from "lodash";
import CreateCampaignFooter from "./CreateCampaignFooter";
import MainCreateCampaign from "./MainCreateCampaign";
import { useCreateNews } from "hooks/useNews";
import { RequestInputCreateNews } from "services/interface/news/news.interface";
import { useAppSelector } from "store";

const CreateCampaign = () => {
  const navigate = useNavigate();

  const [checkIsActive, setCheckIsActive] = useState<boolean>(false);
  const [content, setContent] = useState<string>('')

  const { mutate: createNews, isPending } = useCreateNews();

  const [form] = Form.useForm();

  const factoryId = useAppSelector((state) => state.auth.profile?.user?.role?.ref_id);
  
  const onFinish = (values: any) => {

    let new_main_images: any = [];
    if (values.main_images) {
      new_main_images = values.main_images.map((item: any) => {
        return item.id;
      });
    }

    let new_sub_images: any = [];
    if (values.sub_images) {
      new_sub_images = values.sub_images.map((item: any) => {
        return item.id;
      });
    }

    const createNewsInput : RequestInputCreateNews = {
      topic: values.topic,
      content: content,
      ref_type: "factory",
      ref_id: factoryId ?? '', 
      new_type: values.new_type,
      main_img: new_main_images,
      sub_img: new_sub_images,
      video_url: values.video_url,
      start_date: values.start_date,
      end_date: values.end_date,
      is_ads: values.is_ads,
      is_active: values.is_active,
    };

    createNews(createNewsInput, {
      onSuccess: (data) => {
        if (data.status === "success") {
          message.success("เพิ่มข่าวสารและโปรโมชั่นสำเร็จ");
          navigate("/campaign");
        }else {
          message.error("เพิ่มข่าวสารและโปรโมชั่นไม่สำเร็จ");
        }
      },
      onError: (error) => {
        message.error("เพิ่มข่าวสารและโปรโมชั่นไม่สำเร็จ");
      },
    });
  };

  return (
      <Form
        form={form} onFinish={onFinish}
        labelCol={{
          span: 3 ,
        }}
        layout="horizontal"
        style={{
          // maxWidth: 600,
        }}
      >     
      <Row className="rowgap-vbox" gutter={[24, 0]}>
        <Col span={24}>
          <Card bordered={false} className="criclebox h-full tabs-mobile">
            <HeaderTabs>
              <IconWrapper
                onClick={() => {
                  navigate("/campaign");
                }}
              >
                <SpanIcon>{goBack}</SpanIcon>
              </IconWrapper>
              <Typography.Title level={5}>เพิ่มข่าวสารและโปรโมชั่น</Typography.Title>
              <RightIconWrapper></RightIconWrapper>
            </HeaderTabs>
            <WrapperAll> 
              <MainCreateCampaign
                form={form}
                setContent={setContent}
                content={content}
                setCheckIsActive={setCheckIsActive}
                checkIsActive={checkIsActive}
              />
              
            </WrapperAll>
          </Card>
        </Col>
      </Row>
      <CreateCampaignFooter loading={isPending} />    
    </Form>
  );
};

export default CreateCampaign;

const HeaderTabs = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px;
  flex-direction: row;
  border-bottom: 1px solid #efefef;
`;

const IconWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 30px;
  border-radius: 6px;
  background-color: #ffffff;
  cursor: pointer;
  transition: all 0.3s ease-in-out;
  &:hover {
    background-color: #efefef;
  }
`;

const SpanIcon = styled.span`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
`;

const RightIconWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
`;

const WrapperAll = styled.div`
  display: block;
  width: 100%;
  overflow-y: auto;
  overflow-x: hidden;
`;
